export default "__VITE_ASSET__r02UDG4u__"